import type { PAGE_POSITIONS, PostAuthOptions } from 'types';

import Apple from './Apple';
import Facebook from './Facebook';
import Google from './Google';
import type { SocialButtonAppearance } from './SocialButtonAppearance';

export type Props = {
  appearance?: SocialButtonAppearance;
  onError: (err: string | null) => void;
  onSuccess?: () => void;
  pagePosition: PAGE_POSITIONS;
  postAuthOptions?: PostAuthOptions;
};

export default {
  Apple,
  Facebook,
  Google
};
